import { cameraBannerProduct, carTracking1, enterpriseKit1, peopleTracking1, starterKit1 } from '@assets/images/main/camera';
import {
  productCardBleStarterM,
  productCardBleStarterD,
  productCardBleEnterpriseM,
  productCardBleEnterpriseD,
  productCardAoaStarterM,
  productCardAoaStarterD,
  productCardAoaEnterpriseM,
  productCardAoaEnterpriseD,
  productCardUwbStarterM,
  productCardUwbStarterD,
  productCardUwbEnterpriseM,
  productCardUwbEnterpriseD,
  productCardComfortM,
  productCardComfortD,
  productCardAiStarterM,
  productCardAiStarterD,
  productCardAiServerM,
  productCardAiServerD,
  productCardVehicleM,
  productCardVehicleD,
  productCardYardM,
  productCardYardD,
  productCardCameraM,
  productCardCameraD,
  productCardOutdoorM,
  productCardOutdoorD,
  productCardRtlsM,
  productCardRtlsD,
  productCardAccessM,
  productCardAccessD,
  productCardIotM,
  productCardIotD,
  productCardOrbroOsD,
  productCardOrbroOsM,
} from '@assets/images/main/home/products/all';
import { osBanner } from '@assets/images/main/os/bannerImg';

import { assetTracking1, workerTracking1 } from '@assets/images/main/rtls/product';

export default {
  assetPackage: {
    label: 'Assets Tracking Package',
    title: '자산 위치추적 패키지',
    product: 'TwinTracker 10 + Server 1',
    desc: 'BLE 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
    img: assetTracking1,
    link: '/rtls',
    index: '1',
    productIndex: 1,
  },

  workerPackage: {
    label: 'Workers Tracking Package',
    title: '작업자 위치추적 패키지',
    product: 'TwinTrackerPro 10 + Server 1',
    desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
    img: workerTracking1,
    link: '/rtls',
    index: '2',
    productIndex: 1,
  },

  carPackage: {
    label: 'Vehicle Location Tracking Package',
    title: '차량 위치추적 패키지',
    product: 'Server1 + NVR1 + PTZ Camera2',
    desc: '카메라를 통하여 사람, 차량, 등 다양한 객체의 위치 및 이상 행동을 감지하고 관리 할 수 있습니다.',
    img: carTracking1,
    link: '/camera',
    index: '1',
    productIndex: 1,
  },

  peoplePackage: {
    label: 'People Tracking and Analysis Package',
    title: '유동인구 분석 패키지',
    product: 'Server1 + NVR1 + IP Camera4',
    desc: '카메라를 통하여 실내 사람들의 이동경로를 분석 및 돌발 상황 감지를 할 수 있습니다.',
    img: peopleTracking1,
    link: '/camera',
    index: '2',
    productIndex: 1,
  },

  recommand: '권장 제품',

  cards: [
    {
      type: 'bleStarter',
      title: 'TwinTracker BLE Starter Kit',
      desc: 'ORBRO Edge RTLS, L2 Switch, TwinTracker BLE(4)',
      link: '/rtls/ble',
      img: {
        desktop: productCardBleStarterM,
        tablet: productCardBleStarterM,
        mobile: productCardBleStarterM,
      },
    },
    {
      type: 'bleEnterprise',
      title: 'BLE Enterprise Kit',
      desc: 'ORBRO Server, L2 Switch(2), ORBRO Edge RTLS(2), TwinTracker BLE(12)',
      link: '/rtls/ble',
      img: {
        desktop: productCardBleEnterpriseM,
        tablet: productCardBleEnterpriseM,
        mobile: productCardBleEnterpriseM,
      },
    },
    {
      type: 'aoaStarter',
      title: 'TwinTracker AoA Starter Kit',
      desc: 'ORBRO Edge RTLS, L2 Switch, TwinTracker AoA(4)',
      link: '/rtls/aoa',
      img: {
        desktop: productCardAoaStarterM,
        tablet: productCardAoaStarterM,
        mobile: productCardAoaStarterM,
      },
    },
    {
      type: 'aoaEnterprise',
      title: 'AoA Enterprise Kit',
      desc: 'ORBRO Server, L2 Switch(2), ORBRO Edge RTLS(2), TwinTracker AoA(12)',
      link: '/rtls/aoa',
      img: {
        desktop: productCardAoaEnterpriseM,
        tablet: productCardAoaEnterpriseM,
        mobile: productCardAoaEnterpriseM,
      },
    },
    {
      type: 'uwbStarter',
      title: 'TwinTracker UWB Starter Kit',
      desc: 'ORBRO Server, L2 Switch(2), ORBRO Edge RTLS(2), TwinTracker BLE(12)',
      link: '/rtls/uwb',
      img: {
        desktop: productCardUwbStarterM,
        tablet: productCardUwbStarterM,
        mobile: productCardUwbStarterM,
      },
    },
    {
      type: 'uwbEnterprise',
      title: 'UWB Enterprise Kit',
      desc: 'ORBRO Server, L2 Switch(2), ORBRO Edge RTLS(2), TwinTracker UWB(12)',
      link: '/rtls/uwb',
      img: {
        desktop: productCardUwbEnterpriseM,
        tablet: productCardUwbEnterpriseM,
        mobile: productCardUwbEnterpriseM,
      },
    },
    {
      type: 'comfortKit',
      title: 'Comfort Kit',
      desc: 'Mobile App, UWB Tag(8), UWB Tag',
      link: '/rtls/comfort',
      img: {
        desktop: productCardComfortM,
        tablet: productCardComfortM,
        mobile: productCardComfortM,
      },
    },
    {
      type: 'aiStarter',
      title: 'ORBRO Edge AI Starter Kit',
      desc: 'ORBRO Edge AI, L2 Switch',
      link: '/camera/edge',
      img: {
        desktop: productCardAiStarterM,
        tablet: productCardAiStarterM,
        mobile: productCardAiStarterM,
      },
    },
    {
      type: 'aiServer',
      title: 'ORBRO AI Server Enterprise Kit',
      desc: 'ORBRO AI Server, ORBRO Server',
      link: '/camera/server',
      img: {
        desktop: productCardAiServerM,
        tablet: productCardAiServerM,
        mobile: productCardAiServerM,
      },
    },
    {
      type: 'vehicle',
      title: 'Vehicle Tracking Kit',
      desc: 'ORBRO Server x 1 + GPS Device x 5',
      link: '/outdoor/gps',
      img: {
        desktop: productCardVehicleM,
        tablet: productCardVehicleM,
        mobile: productCardVehicleM,
      },
    },
    {
      type: 'yard',
      title: 'Yard Tracking Kit',
      desc: 'ORBRO Server, LoRa Gateway, GPS Tag(10)',
      link: '/outdoor/lora',
      img: {
        desktop: productCardYardM,
        tablet: productCardYardM,
        mobile: productCardYardM,
      },
    },
    {
      type: 'camera',
      title: '영상 위치 추적',
      desc: 'AI 기반 영상을 통한 객체 추적',
      link: '/camera',
      img: {
        desktop: productCardCameraM,
        tablet: productCardCameraM,
        mobile: productCardCameraM,
      },
    },
    {
      type: 'outdoor',
      title: '야외 위치 추적',
      desc: '차량 및 야드 위치추적',
      link: '/outdoor',
      img: {
        desktop: productCardOutdoorM,
        tablet: productCardOutdoorM,
        mobile: productCardOutdoorM,
      },
    },
    {
      type: 'rtls',
      title: '전파 위치추적',
      desc: 'BLE, AoA, UWB 등 무선 통신 기반 위치 추적',
      link: '/rtls',
      img: {
        desktop: productCardRtlsM,
        tablet: productCardRtlsM,
        mobile: productCardRtlsM,
      },
    },
    {
      type: 'access',
      title: '출입 시스템',
      desc: '자동문, 얼굴인식 등 출입 제어',
      link: '/access',
      img: {
        desktop: productCardAccessM,
        tablet: productCardAccessM,
        mobile: productCardAccessM,
      },
    },
    {
      type: 'iiot',
      title: 'Industry IoT',
      desc: '공기질 · 일산화탄소센서, LoRa게이트웨이, 로봇 등을 연동',
      link: '/iot',
      img: {
        desktop: productCardIotM,
        tablet: productCardIotM,
        mobile: productCardIotM,
      },
    },
    {
      type: 'orbroOs',
      title: 'ORBRO OS',
      desc: 'All Spaces, All Devices, Connected at a Glance on a Digital Platform',
      link: '/os',
      img: {
        desktop: productCardOrbroOsM,
        tablet: productCardOrbroOsM,
        mobile: productCardOrbroOsM,
      },
    },
  ],
};
